/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsUmbrella: {
  name: 'umbrella';
  data: string;
} = {
  name: 'umbrella',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.062 11h15.876a8.002 8.002 0 0 0-15.876 0ZM20 13h-7v6a1 1 0 1 0 2 0 1 1 0 1 1 2 0 3 3 0 0 1-6 0v-6H4c-1.071 0-2.073-.893-1.94-2.108C2.614 5.89 6.852 2 12 2c5.148 0 9.387 3.89 9.94 8.892C22.072 12.107 21.07 13 20 13Z" fill="currentColor"/></svg>`,
};
